/**
 * Cart interstitial: DIY consent for missing custom-build labor.
 * Hard-blocks (materials/cut) show a restore message — no consent escape.
 * Labor gaps can set cart attributes _diy_fletch / _diy_wrap_install.
 */
(function () {
  const HANDLES = {
    fletching: 'custom-fletching-per-dozen',
    wrapMaterials: 'custom-arrow-wrap-installed',
    wrapLabor: 'custom-wrap-install-labor',
    cut: 'cut-arrows',
  };

  function prop(item, key) {
    const p = item && item.properties;
    if (!p) return '';
    if (typeof p === 'object' && !Array.isArray(p)) {
      return p[key] == null ? '' : String(p[key]);
    }
    if (Array.isArray(p)) {
      for (let i = 0; i < p.length; i++) {
        const row = p[i];
        if (row && (row.name === key || row.key === key)) return String(row.value || '');
      }
    }
    return '';
  }

  function norm(s) {
    return String(s || '')
      .trim()
      .toLowerCase();
  }

  function isTruthy(v) {
    const n = norm(v);
    return n === '1' || n === 'true' || n === 'yes';
  }

  function classify(items) {
    let hasFletch = false;
    let fletchIncludesWrap = false;
    let hasWrapMaterials = false;
    let hasWrapLabor = false;
    let hasCut = false;
    let wraps = '';
    let cutLength = '';

    items.forEach(function (item) {
      const handle = norm(item.handle);
      const title = norm(item.product_title || item.title);
      const variant = norm(item.variant_title);
      const blob = title + ' ' + variant;
      const w = prop(item, 'Wraps');
      const c = prop(item, 'Cut Length');
      if (w && norm(w) !== 'none') wraps = w;
      if (c) cutLength = c;

      if (handle === HANDLES.fletching || blob.indexOf('fletching') >= 0) {
        hasFletch = true;
        if (blob.indexOf('wrap') >= 0) fletchIncludesWrap = true;
      }
      if (handle === HANDLES.wrapMaterials) hasWrapMaterials = true;
      if (handle === HANDLES.wrapLabor || blob.indexOf('wrap install labor') >= 0) {
        hasWrapLabor = true;
      }
      if (handle === HANDLES.cut || blob.indexOf('cut arrow') >= 0) hasCut = true;
    });

    const wantWrap = !!(wraps && norm(wraps) !== 'none') || hasWrapMaterials;
    const cutNorm = norm(cutLength);
    const wantCut =
      !!cutLength && cutNorm.indexOf('full') < 0 && cutNorm.indexOf('no cut') < 0;

    return {
      wantWrap: wantWrap,
      wantCut: wantCut,
      hasFletch: hasFletch,
      fletchIncludesWrap: fletchIncludesWrap,
      hasWrapMaterials: hasWrapMaterials,
      hasWrapLabor: hasWrapLabor,
      hasCut: hasCut,
    };
  }

  function buildLabor(items) {
    for (let i = 0; i < items.length; i++) {
      const v = norm(prop(items[i], '_build_labor'));
      if (v === 'titlex' || v === 'wrap_only' || v === 'diy' || v === 'none') return v;
    }
    return null;
  }

  function analyzeCart(cart) {
    const attrs = (cart && cart.attributes) || {};
    const diyFletch = isTruthy(attrs._diy_fletch);
    const diyWrap = isTruthy(attrs._diy_wrap_install);
    const byBuild = {};
    (cart.items || []).forEach(function (item) {
      const bid = prop(item, '_build_id');
      if (!bid) return;
      if (!byBuild[bid]) byBuild[bid] = [];
      byBuild[bid].push(item);
    });

    const hard = [];
    const labor = { needFletch: false, needWrapInstall: false };

    Object.keys(byBuild).forEach(function (bid) {
      const items = byBuild[bid];
      const c = classify(items);
      const intent = buildLabor(items);
      if (c.wantWrap && !c.hasWrapMaterials) {
        hard.push(
          'A custom build is missing wrap materials. Restore them from the arrow builder (materials cannot be skipped).'
        );
      }
      if (c.wantCut && !c.hasCut) {
        hard.push(
          'A custom build is missing the cut-arrows charge. Restore it from the builder or choose Full Shaft (No Cut).'
        );
      }

      if (intent === 'none') {
        // Intentional bare — never ask for fletch consent
        if (c.wantWrap) {
          const wrapOk = c.fletchIncludesWrap || c.hasWrapLabor || diyWrap;
          if (!wrapOk) labor.needWrapInstall = true;
        }
        return;
      }

      if (intent === 'wrap_only') {
        if (c.wantWrap && !c.hasWrapLabor && !diyWrap) labor.needWrapInstall = true;
        return;
      }

      if (c.wantWrap) {
        const wrapLaborOk =
          c.fletchIncludesWrap || c.hasWrapLabor || diyWrap || (diyFletch && diyWrap);
        const fletchOk = c.hasFletch || diyFletch || c.hasWrapLabor || intent === 'diy';
        if (!fletchOk) labor.needFletch = true;
        if (!wrapLaborOk) labor.needWrapInstall = true;
      } else if (!c.hasFletch && !diyFletch) {
        labor.needFletch = true;
      }
    });

    return {
      hasBuilds: Object.keys(byBuild).length > 0,
      hard: hard,
      labor: labor,
      needsConsent: !hard.length && (labor.needFletch || labor.needWrapInstall),
    };
  }

  function ensureModal() {
    let root = document.getElementById('BuildCheckoutConsent');
    if (root) return root;
    root = document.createElement('div');
    root.id = 'BuildCheckoutConsent';
    root.className = 'build-consent';
    root.hidden = true;
    root.setAttribute('role', 'dialog');
    root.setAttribute('aria-modal', 'true');
    root.setAttribute('aria-labelledby', 'BuildCheckoutConsentTitle');
    root.innerHTML =
      '<div class="build-consent__backdrop" data-consent-dismiss></div>' +
      '<div class="build-consent__panel">' +
      '<h2 id="BuildCheckoutConsentTitle" class="build-consent__title">Confirm DIY labor</h2>' +
      '<p class="build-consent__lead" data-consent-lead></p>' +
      '<div class="build-consent__checks" data-consent-checks></div>' +
      '<p class="build-consent__hard" data-consent-hard hidden></p>' +
      '<div class="build-consent__actions">' +
      '<button type="button" class="button button--secondary" data-consent-dismiss>Go back</button>' +
      '<button type="button" class="button" data-consent-accept hidden>Confirm &amp; continue</button>' +
      '<a class="button" data-consent-builder href="/pages/3d-custom-arrow-builder" hidden>Return to builder</a>' +
      '</div>' +
      '</div>';
    document.body.appendChild(root);
    return root;
  }

  function openModal(analysis, onAccept) {
    const root = ensureModal();
    const lead = root.querySelector('[data-consent-lead]');
    const checks = root.querySelector('[data-consent-checks]');
    const hardEl = root.querySelector('[data-consent-hard]');
    const acceptBtn = root.querySelector('[data-consent-accept]');
    const builderLink = root.querySelector('[data-consent-builder]');

    checks.innerHTML = '';
    hardEl.hidden = true;
    hardEl.textContent = '';
    acceptBtn.hidden = true;
    builderLink.hidden = true;

    if (analysis.hard.length) {
      lead.textContent =
        'Checkout is blocked until this custom build is complete. TitleX cannot skip wrap materials or cut charges.';
      hardEl.hidden = false;
      hardEl.textContent = analysis.hard.join(' ');
      builderLink.hidden = false;
    } else {
      lead.textContent =
        'TitleX will not install the missing service(s). Confirm you will do this yourself, or go back and restore labor from the builder.';
      if (analysis.labor.needFletch) {
        const label = document.createElement('label');
        label.className = 'build-consent__check';
        label.innerHTML =
          '<input type="checkbox" data-diy-fletch /> I will fletch these arrows myself. TitleX will not fletch them.';
        checks.appendChild(label);
      }
      if (analysis.labor.needWrapInstall) {
        const label = document.createElement('label');
        label.className = 'build-consent__check';
        label.innerHTML =
          '<input type="checkbox" data-diy-wrap /> I will apply arrow wraps myself. TitleX will not install wraps.';
        checks.appendChild(label);
      }
      acceptBtn.hidden = false;
    }

    root.hidden = false;
    document.documentElement.classList.add('build-consent-open');

    function close() {
      root.hidden = true;
      document.documentElement.classList.remove('build-consent-open');
      root.removeEventListener('click', onClick);
    }

    function onClick(e) {
      const t = e.target;
      if (t && t.closest && t.closest('[data-consent-dismiss]')) {
        e.preventDefault();
        close();
        return;
      }
      if (t && t.closest && t.closest('[data-consent-accept]')) {
        e.preventDefault();
        const needF = analysis.labor.needFletch;
        const needW = analysis.labor.needWrapInstall;
        const fEl = root.querySelector('[data-diy-fletch]');
        const wEl = root.querySelector('[data-diy-wrap]');
        const okF = !needF || (fEl && fEl.checked);
        const okW = !needW || (wEl && wEl.checked);
        if (!okF || !okW) {
          lead.textContent = 'Check each DIY box to continue, or go back and restore labor.';
          return;
        }
        acceptBtn.disabled = true;
        onAccept({
          diyFletch: needF,
          diyWrap: needW,
        }).finally(function () {
          acceptBtn.disabled = false;
          close();
        });
      }
    }

    root.addEventListener('click', onClick);
  }

  function updateCartAttributes(payload) {
    const attributes = {};
    if (payload.diyFletch) attributes._diy_fletch = '1';
    if (payload.diyWrap) attributes._diy_wrap_install = '1';
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attributes }),
    }).then(function (res) {
      return res.json().then(function (body) {
        if (!res.ok) throw new Error((body && body.description) || 'Could not save consent');
        return body;
      });
    });
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (res) {
      return res.json();
    });
  }

  function proceedToCheckout() {
    window.location.href = '/checkout';
  }

  function gateCheckout(event) {
    const btn = event.target && event.target.closest && event.target.closest('[name="checkout"]');
    if (!btn) return;
    event.preventDefault();
    event.stopPropagation();
    fetchCart()
      .then(function (cart) {
        const analysis = analyzeCart(cart);
        if (!analysis.hasBuilds) {
          proceedToCheckout();
          return;
        }
        if (!analysis.hard.length && !analysis.needsConsent) {
          proceedToCheckout();
          return;
        }
        openModal(analysis, function (payload) {
          return updateCartAttributes(payload).then(function () {
            proceedToCheckout();
          });
        });
      })
      .catch(function (err) {
        console.warn('[build-consent] gate failed', err);
        proceedToCheckout();
      });
  }

  document.addEventListener('click', gateCheckout, true);

  window.TitleXBuildConsent = {
    analyzeCart: analyzeCart,
    openModal: openModal,
  };
})();
